<div class="container-page">
    <div class="container-header">
        <img src="assets/images/logos/nexus-d.png" alt="Logo" class="logo" />
    </div>

    @if (!confirmoPreRegistro) {
    <div class="container-card-preregistro">
        <app-pre-registro (validChange)="onPreRegistroValidChange($event)" (requiereVehiculoChange)="onRequiereVehiculoChange($event)"></app-pre-registro>
    </div>

    } @if (confirmoPreRegistro) {
    <div class="container-card">
        <mat-stepper orientation="vertical" #stepper [linear]="true" (selectionChange)="onStepChange($event)">
            <mat-step [completed]="stepDatosBasicosValid">
                <ng-template matStepLabel>Datos básicos</ng-template>
                <app-datos-basicos (validChange)="onDatosBasicosValidChange($event)"></app-datos-basicos>

                <div class="align-right">
                    <button
                        miButton="primary"
                        [disabled]="!stepDatosBasicosValid"
                        [miButtonIcon]="'solar:arrow-right-broken'"
                        (click)="saveDatosBasicos()"
                    >
                        Siguiente
                    </button>
                </div>
            </mat-step>
            <mat-step [completed]="stepDatosBasicosAdicionalesValid">
                <ng-template matStepLabel>Datos básicos adicionales</ng-template>
                <app-datos-basicos-adicionales (validChange)="onDatosBasicosAdicionalesValidChange($event)"></app-datos-basicos-adicionales>

                <div class="align-right gap-2">
                    <button miButton="back" [miButtonIcon]="'solar:arrow-left-broken'" matStepperPrevious>Anterior</button>
                    <button
                        miButton="primary"
                        [disabled]="!stepDatosBasicosAdicionalesValid"
                        [miButtonIcon]="'solar:arrow-right-broken'"
                        (click)="saveDatosBasicosAdicionales()"
                    >
                        Siguiente
                    </button>
                </div>
            </mat-step>
            @if (requiereVehiculo) {
            <mat-step [completed]="stepVehicularValid">
                <ng-template matStepLabel>Información vehicular</ng-template>
                <app-info-vehicular [idEncrypt]="idEncrypt" (validChange)="onVehicularValidChange($event)"></app-info-vehicular>
                <div class="align-right gap-2">
                    <button miButton="back" [miButtonIcon]="'solar:arrow-left-broken'" matStepperPrevious>Anterior</button>
                    <button miButton="primary" [miButtonIcon]="'solar:arrow-right-broken'" matStepperNext [disabled]="!stepVehicularValid">
                        Siguiente
                    </button>
                </div>
            </mat-step>
            }
            <mat-step [completed]="stepAcademicValid">
                <ng-template matStepLabel>Información académica</ng-template>
                <app-info-academica [codEmp]="codEmp" [tipIde]="tipIde" (validChange)="onAcademicValidChange($event)"></app-info-academica>
                <div class="align-right gap-2">
                    <button miButton="back" [miButtonIcon]="'solar:arrow-left-broken'" matStepperPrevious>Anterior</button>
                    <button miButton="primary" [miButtonIcon]="'solar:arrow-right-broken'" matStepperNext [disabled]="!stepAcademicValid">
                        Siguiente
                    </button>
                </div>
            </mat-step>
            <mat-step [completed]="stepWorkingValid">
                <ng-template matStepLabel>Información laboral</ng-template>
                <app-info-laboral [codEmp]="codEmp" [tipIde]="tipIde" (validChange)="onWorkingValidChange($event)"></app-info-laboral>
                <div class="align-right gap-2">
                    <button miButton="back" [miButtonIcon]="'solar:arrow-left-broken'" matStepperPrevious>Anterior</button>
                    <button
                        miButton="primary"
                        [miButtonIcon]="'solar:arrow-right-broken'"
                        (click)="infoLaboral()"
                        [disabled]="!stepWorkingValid"
                    >
                        Siguiente
                    </button>
                </div></mat-step
            >
            <mat-step [completed]="stepDocumentosValid">
                <ng-template matStepLabel>Documentación (opcional)</ng-template>
                <app-info-documentos
                    [codEmp]="codEmp"
                    [tipIde]="tipIde"
                    (validChange)="onDocumentosValidChange($event)"
                ></app-info-documentos>
                <div class="align-right gap-2">
                    <button miButton="back" [miButtonIcon]="'solar:arrow-left-broken'" matStepperPrevious>Anterior</button>
                    <button
                        miButton="primary"
                        [miButtonIcon]="'solar:arrow-right-broken'"
                        [disabled]="!stepDocumentosValid"
                        (click)="saveDocuments()"
                    >
                        Siguiente
                    </button>
                </div></mat-step
            >
            <mat-step>
                <ng-template matStepLabel>Finalizar</ng-template>
                <div class="text-center m-5">
                    <app-info-finalizar (validChange)="onFinalizarValidChange($event)"></app-info-finalizar>
                </div>
                <div class="align-right gap-2">
                    <button miButton="back" [miButtonIcon]="'solar:arrow-left-broken'" matStepperPrevious>Anterior</button>
                    <button
                        miButton="primary"
                        [miButtonIcon]="'solar:arrow-right-broken'"
                        [disabled]="!stepFinalizarValid"
                        (click)="finaliceProcess()"
                    >
                        Finalizar
                    </button>
                </div></mat-step
            >
        </mat-stepper>
    </div>
    }

    <div class="container-footer">
        <span class="text-xs">© 2025 Misión Empresarial. Todos los derechos reservados.</span>
    </div>
</div>
